import { render, staticRenderFns } from "./ParticipantControls.vue?vue&type=template&id=55a896b0&"
import script from "./ParticipantControls.vue?vue&type=script&lang=js&"
export * from "./ParticipantControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports